import React from 'react';

type IProps = {}
const Instruction: React.FC<IProps> = (props) => {
  return (
    <div className="card-container">
      <div className="card">
        <div className="card-header">投保限制</div>
        <div className="card-section">
          <b>飼主</b>
          <p>●要保人投保年齡限18歲以上</p>
          <p>●首次投保需先完成會員註冊</p>
          <p>●本國籍自然人</p>
          <p>●要保人與被保險人須為同一人</p>
        </div>
        <div className="card-section">
          <b>寵物</b>
          <p>僅接受已向農業部辦理登記並植入晶片之寵物投保。</p>
        </div>
        <div className="card-section">
          <b>保期</b>
          <p>保單生效日為「翌日零時」，最長可選一週內為生效日期，保險期間為期一年。（提醒您，投保申請每日晚上11點(含) 後申請，生效日為翌日+1日零時），但保險公司仍保留承保與否之權力。</p>
        </div>
        <div className="card-section">
          <b>繳費方式</b>
          <p>本人信用卡(驗證要、被保險人身份必須為本人)。</p>
        </div>

      </div>
      <div className="card">
        <div className="card-header">指定動物醫院</div>
        <div className="card-section">
          <p>被保險寵物發生保險事故的疾病或傷害，其診療行為僅限於指定獸醫院進行，否則保險公司不負賠償之責。
            <span>( 醫院僅聲明加入指定醫療，非為保險公司委託單位)</span>
          </p>
        </div>
      </div>
      <div className="card">
        <div className="card-header">投保年齡/寵物</div>
        <div className="card-section">
          <b>年齡</b>
          <p>首次投保年齡以滿2個月起至8歲6個月以下者為限，最高續保年齡則無限制。本保險為非保證續保商品，且依寵物續保年齡之不同，按當時主管機關核可的保險費率計算保費。</p>
        </div>
        <div className="card-section">
          <b>寵物</b>
          <p>指因玩賞、伴侶之目的而飼養或管領之犬隻或貓隻，
            <span>但不包含供做出租或販售、從事競賽、獵捕、特技表演、專門繁殖用、醫學用、工作犬（如：校犬、搜救犬、軍犬、警犬、緝毒犬、導盲犬）用等。</span>
          </p>
        </div>
      </div>
      <div className="card">
        <div className="card-header">理賠限制</div>
        <div className="card-section">
          <b>疾病等待期</b>
          <p>保單生效日起持續有效達下列期間或續保日後所發生，始可申請：</p>
          <p>＊90日：癌症、膝蓋骨異位、髖關節發育不良、椎間盤突出、心臟疾病、腎臟疾病、癲癇、糖尿病或甲狀腺疾病。</p>
          <p>＊30日：非前目所載之其他疾病。</p>
        </div>
        <div className="card-section">
          <b>醫療費用</b>
          <p>皮膚相關疾病限賠2次。針對同一疾病或傷害，或因此引起之併發症，14日內於任何獸醫院再次診療時，保險公司對各項保險金給付合計額，視為同一保險事故(詳見常見問題)。</p>
        </div>
        <div className="card-section">
          <b>自負額</b>
          <p>被保險人於保險期間發生承保範圍內之損失時，對於每一次損失，須先負擔本保險契約所約定之自負額，本公司僅就超過自負額部份之損失負理賠責任。</p>
        </div>
      </div>
    </div>
  );
};

export default Instruction;
